import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    createQuestionApi,
    getQuestionsApi,
    updateQuestionApi,
    getSubmissionsApi,
    getSubmissionAnswersApi,
    downloadSubmissionApi,
} from "./feedbackApi";


export const getQuestions = createAsyncThunk(
    "feedback/getQuestions",
    async (params, thunkAPI) => {
        try {
            const res = await getQuestionsApi(params);

            const locations = res.data.data.items || [];

            const questions = locations.flatMap((loc) =>
                (loc.questions || []).map((q) => ({
                    ...q,
                    locationName: loc.name,
                }))
            );

            return {
                list: questions,
                total: questions.length,
            };

        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const createQuestion = createAsyncThunk(
    "feedback/createQuestion",
    async (data, thunkAPI) => {
        try {
            const res = await createQuestionApi(data);
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const updateQuestion = createAsyncThunk(
    "feedback/updateQuestion",
    async ({ id, data }, thunkAPI) => {
        try {
            const res = await updateQuestionApi(id, data);
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);


export const getSubmissions = createAsyncThunk(
    "feedback/getSubmissions",
    async (params, thunkAPI) => {
        try {
            const res = await getSubmissionsApi(params);

            return {
                list: res.data.data.items || [],
                total: res.data.data.total || 0,
            };
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const getSubmissionAnswers = createAsyncThunk(
    "feedback/getSubmissionAnswers",
    async (submissionId, thunkAPI) => {
        try {
            const res = await getSubmissionAnswersApi(submissionId);
            return res.data.data.answers || [];
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const downloadSubmission = createAsyncThunk(
    "feedback/downloadSubmission",
    async (locationId, thunkAPI) => {
        try {
            const res = await downloadSubmissionApi(locationId);

            const contentDisposition = res.headers["content-disposition"];
            let fileName = "submissions.xlsx"; // fallback

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            const blob = new Blob([res.data], {
                type: res.headers["content-type"],
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            return true;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);


const slice = createSlice({
    name: "feedback",
    initialState: {
        questions: [],
        submissions: [],
        answers: [],
        total: 0,
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getQuestions.fulfilled, (state, action) => {
                state.questions = action.payload.list || [];
                state.total = action.payload.total || 0;
            })

            .addCase(getSubmissions.fulfilled, (state, action) => {
                state.submissions = action.payload.list;
                state.total = action.payload.total;
            })

            .addCase(getSubmissionAnswers.fulfilled, (state, action) => {
                state.answers = action.payload;
            });
    },
});

export default slice.reducer;